import { ShopifyProductBasicRes } from '@aether/models'

export const isVipProduct = (item: ShopifyProductBasicRes | null) => {
  return item?.vipProduct?.value === 'true'
}
